import { type CellContext, RowActionsWrapper } from "@msuite/ui/table";
import type { IncomingInvoiceDashboardListItem } from "@msuite/utils/types";

/** A row opens its invoice. */
export function RowActions({ cell }: CellContext<IncomingInvoiceDashboardListItem, "actions">) {
	/** Render */
	return <RowActionsWrapper to={`/controlling/incoming-invoices/${cell.row.original.id}`} />;
}
